export default __webpack_public_path__ + "static/media/jandj.e64f3b4a.png";